import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Code2,
  Coffee,
  Layers,
  Megaphone,
  BarChart3,
  BrainCircuit,
  Cpu,
  PenTool,
  Palette,
  Clapperboard,
  GraduationCap,
  ArrowUpRight,
} from "lucide-react";
import { publicApi } from "../admin/adminApi";
import useScrollReveal from "../hooks/useScrollReveal";
import useScrollProgress from "../hooks/useScrollProgress";
import AscentLine from "./AscentLine";
import "./Courses.css";
const ICONS = {
  python: Code2,
  java: Coffee,
  fullstack: Layers,
  "digital-marketing": Megaphone,
  "data-analyst": BarChart3,
  "data-science": BrainCircuit,
  ai: Cpu,
  "ui-ux": PenTool,
  "graphic-design": Palette,
  "video-editing": Clapperboard,
};
export default function Courses() {
  const [progressRef, progress] = useScrollProgress();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const revealRef = useScrollReveal(undefined, [loading, courses.length]);
  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const data = await publicApi.listCourses();
        if (!cancelled) setCourses(data);
      } catch {
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);
  return (
    <section className="courses" id="courses" ref={revealRef}>
      <div className="container">
        <div className="section-head center reveal">
          <span className="eyebrow">10+ Career Tracks</span>
          <h2>Choose Your Career Track. We'll Help You Get There.</h2>
          <p>
            Every learner has a different destination. Whether you're starting
            your first tech career, switching industries, or upgrading your
            skills, our live online courses are designed to help you learn with
            clarity, practice consistently, and build real-world experience.
          </p>
          <p>
            Every program includes mentor guidance, hands-on assignments,
            practical projects, and structured learning—not just recorded
            videos.
          </p>
        </div>

        <div className="courses__field" ref={progressRef}>
          <AscentLine progress={progress} />
          {loading ? (
            <p style={{ textAlign: "center" }}>Loading courses…</p>
          ) : courses.length === 0 ? (
            <p style={{ textAlign: "center" }}>Courses will appear here soon.</p>
          ) : (
          <div className="courses__grid">
            {courses.map((course, i) => {
              const Icon = ICONS[course.slug] || GraduationCap;
              return (
                <Link
                  key={course._id || course.slug}
                  to={`/courses/${course.slug}`}
                  className={`course-card reveal reveal-delay-${(i % 5) + 1}${
                    i % 2 === 1 ? " course-card--offset" : ""
                  }`}
                >
                  <span className="course-card__ghost">{String(i + 1).padStart(2, "0")}</span>
                  <span className="course-card__code">{course.code}</span>
                  <span className="course-card__icon">
                    <Icon size={22} strokeWidth={2} />
                  </span>
                  <h3>{course.name}</h3>
                  <p>{course.tagline}</p>
                  <div className="course-card__foot">
                    <span className="course-card__level">{course.level}</span>
                    <span className="course-card__enquire">
                      <ArrowUpRight size={15} /> View Course
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
          )}
        </div>
      </div>
    </section>
  );
}